import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Nav from './blocks/Nav';
import Footer from './blocks/Footer';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Nav />
    <App/>
    <Footer />
  </React.StrictMode>
);